var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.showTaskInfo
        ? [
            _c("p", [
              _vm._v("Препарат: "),
              _c("strong", [_vm._v(_vm._s(_vm.task.task_data?.drug?.title))]),
            ]),
            _vm._v(" "),
            _c("p", [_vm._v(_vm._s(_vm.task.task_data?.drug?.group))]),
            _vm._v(" "),
            _vm.task.task_data?.comment
              ? _c("p", [_vm._v(_vm._s(_vm.task.task_data.comment))])
              : _vm._e(),
          ]
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { class: { "mt-2": _vm.showTaskInfo } },
        [
          _c("CommentsBlock", {
            ref: "commentBlock",
            attrs: { task: _vm.task, updateTasks: _vm.updateTasks },
          }),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }